import { CreateTagReq, UpdateTagReq } from '../dto/ReqDtoRepository';
import { SimpleStringResponse, TagListResponse, TagResponse } from '../dto/ResDtoRepository';
import { sendApiRequest, sendDeleteApiRequest, sendGetApiRequest } from './apiConfig';

export const getGroupMemberTagList = async (aui: string): Promise<TagListResponse> =>
  sendGetApiRequest<TagListResponse>(
    `/api/v1/group-member-tag/list?aui=${encodeURIComponent(aui)}`,
  );

export const createGroupMemberTag = async (
  aui: string,
  data: CreateTagReq,
): Promise<TagResponse> =>
  sendApiRequest<TagResponse>(
    'post',
    `/api/v1/group-member-tag?aui=${encodeURIComponent(aui)}`,
    data,
  );

export const updateGroupMemberTag = async (
  aui: string,
  data: UpdateTagReq,
): Promise<TagResponse> =>
  sendApiRequest<TagResponse>(
    'put',
    `/api/v1/group-member-tag?aui=${encodeURIComponent(aui)}`,
    data,
  );

export const deleteGroupMemberTag = async (
  aui: string,
  tagId: number,
): Promise<SimpleStringResponse> =>
  sendDeleteApiRequest<SimpleStringResponse>(
    `/api/v1/group-member-tag?aui=${encodeURIComponent(aui)}&tagId=${encodeURIComponent(String(tagId))}`,
  );
